import React, { useState } from "react";
import "../loginSignupPage.css";

import TokenInput from "./TokenInput";

import { useForgetPassword } from "../../../contexts/ForgetPasswordContext";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useCountdown } from "../../../hooks/useCountDown";

import Loader from "../../commonComponents/Loader/Loader";

export default function FPStep2() {
  const { allowSecondStep, secondStep, resendCode } = useForgetPassword();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const time = new Date().getTime() + 90000;
  const [minutes, seconds, setTargetDate] = useCountdown(time);

  if (!allowSecondStep()) return <Navigate to="/forget-password" replace />;

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    if (token.replace(" ", "").length !== 6) {
      toast.error("لطفا کد صحیح را وارد کنید");
      setIsLoading(false);
      return;
    }

    try {
      await secondStep(token);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    navigate("/forget-password/password-reset");
  }

  const onChange = (value) => setToken(value);

  async function handleResend(e) {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    try {
      await resendCode();
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }

    const newTime = new Date().getTime() + 90000;
    setIsLoading(false);
    setTargetDate(newTime);
  }

  return (
    <form action="" className="log_sign-form" onSubmit={handleSubmit}>
      <h2 className="forget-pass-header">کد ارسال شده را وارد کنید</h2>
      <TokenInput token={token} setToken={onChange} />
      {minutes + seconds > 0 ? (
        <p className="forget-resend-text">
          ارسال مجدد کد پس از{" "}
          <span>
            {minutes}:
            {seconds.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
            })}
          </span>
        </p>
      ) : (
        <p className="forget-resend-text resend-link" onClick={handleResend}>
          ارسال مجدد کد
        </p>
      )}
      <button disabled={isLoading} className="log_sign-button red-submit-btn">
        {isLoading ? <Loader loading={isLoading} small dark /> : "مرحله بعدی"}
      </button>
    </form>
  );
}
